module.exports = __webpack_public_path__ + "img/pista.a4f48877.png";